(function () {
    var triggers = document.querySelectorAll('.custom-lang-currency-trigger');
    var panels = document.querySelectorAll('.custom-lang-currency-panel');

    // ---------------------------------------------------------------------------
    // Helpers
    // ---------------------------------------------------------------------------

    function isNoDomain() {
        return window.location.hostname.endsWith('.no');
    }

    function isThemeEditorOrPreview() {
        return window.location.search.indexOf('oseid=') !== -1;
    }

    // ---------------------------------------------------------------------------
    // Auto-set default currency on first visit (.com → EUR, .no → NOK)
    // Skipped entirely inside the Theme Editor / preview because /localization
    // returns 404 in that context.
    // ---------------------------------------------------------------------------

    function setDefaultCurrency() {
        if (isThemeEditorOrPreview()) return;

        var onNoDomain = isNoDomain();
        var cookieName = 'currency_default_v2_' + (onNoDomain ? 'no' : 'com');
        if (document.cookie.indexOf(cookieName + '=1') !== -1) return;

        var wrapper = document.querySelector('.custom-lang-currency-wrapper');
        if (!wrapper) return;

        var currentCurrency = wrapper.getAttribute('data-current-currency');
        var expectedCurrency = onNoDomain ? 'NOK' : 'EUR';

        if (currentCurrency === expectedCurrency) {
            document.cookie = cookieName + '=1; path=/; max-age=' + (30 * 24 * 60 * 60) + '; SameSite=Lax';
            return;
        }

        var countryCode = onNoDomain
            ? wrapper.getAttribute('data-nok-country')
            : wrapper.getAttribute('data-eur-country');
        if (!countryCode) return;

        var localeCode = onNoDomain
            ? (wrapper.getAttribute('data-no-locale') || 'no')
            : 'en';

        var formData = new FormData();
        formData.append('country_code', countryCode);
        formData.append('locale_code', localeCode);

        fetch('/localization', { method: 'POST', body: formData })
            .then(function (response) {
                if (!response.ok) return;
                document.cookie = cookieName + '=1; path=/; max-age=' + (30 * 24 * 60 * 60) + '; SameSite=Lax';
                if (onNoDomain) {
                    window.location.href = window.location.origin + '/';
                } else {
                    window.location.reload();
                }
            })
            .catch(function () {
                // Network error — don't set cookie so it retries next visit
            });
    }

    setDefaultCurrency();

    // ---------------------------------------------------------------------------
    // Panel setup (runs for each trigger/panel pair: desktop + mobile)
    // ---------------------------------------------------------------------------

    triggers.forEach(function (trigger, index) {
        var panel = panels[index];
        if (!trigger || !panel) return;

        var panelClose = panel.querySelector('.panel-close');
        var panelOverlay = panel.querySelector('.panel-overlay');
        var weglotLanguageList = panel.querySelector('.weglot-language-list');
        var currentLangDisplay = trigger.querySelector('#current-lang-display');

        // -- Open / close ---------------------------------------------------

        trigger.addEventListener('click', function (e) {
            e.preventDefault();
            e.stopPropagation();
            panel.classList.add('active');
            document.body.style.overflow = 'hidden';
            updateActiveLanguage();
        });

        function closePanel() {
            panel.classList.remove('active');
            document.body.style.overflow = '';
        }

        if (panelClose) panelClose.addEventListener('click', closePanel);
        if (panelOverlay) panelOverlay.addEventListener('click', closePanel);

        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' && panel.classList.contains('active')) {
                closePanel();
            }
        });

        // -- Language detection helpers -------------------------------------

        function isOnWeglotPage() {
            return /^\/(de|fr|it|es|nl)(\/|$)/.test(window.location.pathname);
        }

        function getCurrentWeglotLang() {
            var m = window.location.pathname.match(/^\/(de|fr|it|es|nl)/);
            return m ? m[1] : null;
        }

        function getCurrentPagePath() {
            var path = window.location.pathname
                .replace(/^\/(de|fr|it|es|nl)(\/|$)/, '$2')
                .replace(/^\/no(\/|$)/, '$1')
                .replace(/^\/nb(\/|$)/, '$1')
                .replace(/^\/en(\/|$)/, '$1');
            if (!path || path.charAt(0) !== '/') path = '/' + path;
            return path;
        }

        function hasEnPrefix() {
            var p = window.location.pathname;
            return p === '/en' || p.indexOf('/en/') === 0;
        }

        function hasNoPrefix() {
            var p = window.location.pathname;
            return p === '/no' || p.indexOf('/no/') === 0 ||
                   p === '/nb' || p.indexOf('/nb/') === 0;
        }

        function getCurrentShopifyLang() {
            if (isNoDomain()) {
                return hasEnPrefix() ? 'en' : 'no';
            }
            return hasNoPrefix() ? 'no' : 'en';
        }

        // -- Update trigger & active states ---------------------------------

        function updateTriggerButton() {
            if (!currentLangDisplay) return;
            var wl = getCurrentWeglotLang();
            if (wl) {
                currentLangDisplay.textContent = wl.toUpperCase();
            } else {
                var lang = getCurrentShopifyLang();
                currentLangDisplay.textContent = (lang === 'no' || lang === 'nb') ? 'NOR' : 'ENG';
            }
        }

        function updateActiveLanguage() {
            panel.querySelectorAll('.language-option-custom').forEach(function (el) {
                el.classList.remove('active');
            });

            if (isOnWeglotPage()) {
                var wCode = getCurrentWeglotLang();
                if (wCode) {
                    panel.querySelectorAll('.weglot-link').forEach(function (el) {
                        if (el.getAttribute('data-lang') === wCode) el.classList.add('active');
                    });
                }
            } else {
                var cur = getCurrentShopifyLang();
                panel.querySelectorAll('.shopify-lang-link').forEach(function (el) {
                    var lc = el.getAttribute('data-lang');
                    if (cur === 'no' || cur === 'nb') {
                        if (lc === 'no' || lc === 'nb') el.classList.add('active');
                    } else {
                        if (lc === 'en') el.classList.add('active');
                    }
                });
            }
        }

        // -- Shopify language switching -------------------------------------

        var shopifyLanguageForm = panel.querySelector('#HeaderLanguageFormCustom');
        if (shopifyLanguageForm) {
            shopifyLanguageForm.addEventListener('submit', function (e) {
                e.preventDefault();
                var langCode = e.submitter && e.submitter.getAttribute('data-lang');
                if (!langCode) return;

                var pagePath = getCurrentPagePath();
                var onNo = isNoDomain();
                var targetUrl;

                if (langCode === 'no' || langCode === 'nb') {
                    targetUrl = onNo
                        ? window.location.origin + pagePath
                        : window.location.origin + (pagePath === '/' ? '/no' : '/no' + pagePath);
                } else {
                    targetUrl = onNo
                        ? window.location.origin + (pagePath === '/' ? '/en' : '/en' + pagePath)
                        : window.location.origin + pagePath;
                }

                var fd = new FormData();
                fd.append('locale_code', langCode);

                if (isThemeEditorOrPreview()) {
                    window.location.href = targetUrl;
                    return;
                }

                fetch('/localization', { method: 'POST', body: fd })
                    .then(function () { window.location.href = targetUrl; })
                    .catch(function () { window.location.href = targetUrl; });
            });
        }

        // -- Currency switching ---------------------------------------------

        var currencyForm = panel.querySelector('#CustomCurrencyForm');
        if (currencyForm) {
            currencyForm.querySelectorAll('input[type="radio"]').forEach(function (input) {
                input.addEventListener('change', function () {
                    if (!this.checked) return;
                    panel.querySelectorAll('.currency-column .option-item').forEach(function (el) {
                        el.classList.remove('selected');
                    });
                    this.closest('.option-item').classList.add('selected');
                    currencyForm.submit();
                });
            });
        }

        // -- Weglot languages -----------------------------------------------

        var weglotLanguageDefs = [
            { code: 'DE', lang: 'de', name: 'Deutsch' },
            { code: 'FR', lang: 'fr', name: 'Français' },
            { code: 'IT', lang: 'it', name: 'Italiano' },
            { code: 'ES', lang: 'es', name: 'Español' },
            { code: 'NL', lang: 'nl', name: 'Nederlands' }
        ];

        function getWeglotBaseDomain() {
            if (isNoDomain()) {
                return window.location.protocol + '//' +
                       window.location.hostname.replace(/\.no$/, '.com');
            }
            return window.location.origin;
        }

        function renderWeglotLanguages(languages) {
            if (!weglotLanguageList) return;
            var html = '';
            languages.forEach(function (lang) {
                html += '<a href="#" class="language-option-custom weglot-link" data-lang="' +
                        lang.lang + '"><span class="option-name">' + lang.name +
                        '</span><span class="option-code">' + lang.code + '</span></a>';
            });
            weglotLanguageList.innerHTML = html;

            weglotLanguageList.querySelectorAll('.weglot-link').forEach(function (link) {
                link.addEventListener('click', function (e) {
                    e.preventDefault();
                    var lc = this.getAttribute('data-lang');
                    var pp = getCurrentPagePath();
                    var base = getWeglotBaseDomain();
                    window.location.href = base + '/' + lc + (pp === '/' ? '' : pp);
                });
            });

            updateTriggerButton();
            updateActiveLanguage();
        }

        function extractWeglotLanguages() {
            var switcher = document.querySelector('.weglot-container[data-switcher-id="1"]');
            if (!switcher || !weglotLanguageList) return false;

            var options = switcher.querySelectorAll('.language-list .language-option a');
            var active = switcher.querySelector('.active-language a');
            var langs = [];

            if (active) {
                var ac = active.textContent.trim();
                if (ac !== 'EN' && ac !== 'NO') {
                    var def = weglotLanguageDefs.find(function (d) { return d.code === ac; });
                    langs.push({ code: ac, lang: active.getAttribute('lang') || ac.toLowerCase(), name: def ? def.name : ac });
                }
            }

            options.forEach(function (link) {
                var c = link.textContent.trim();
                if (c !== 'EN' && c !== 'NO') {
                    var d = weglotLanguageDefs.find(function (x) { return x.code === c; });
                    langs.push({ code: c, lang: link.getAttribute('lang') || c.toLowerCase(), name: d ? d.name : c });
                }
            });

            if (!langs.length) return false;
            renderWeglotLanguages(langs);
            return true;
        }

        // -- Initialise -----------------------------------------------------

        updateTriggerButton();
        updateActiveLanguage();

        var attempts = 0;
        function tryExtractLanguages() {
            if (extractWeglotLanguages()) return;
            if (++attempts < 10) {
                setTimeout(tryExtractLanguages, 500);
            } else {
                renderWeglotLanguages(weglotLanguageDefs);
            }
        }

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', tryExtractLanguages);
        } else {
            tryExtractLanguages();
        }
    });
})();
